import {FaseNav} from "./fasenav/FaseNav";
import {ContentWrapper} from "./containers/ContentWrapper";
import React from 'react';
import {ContentPagePreloader} from "./containers/ContentPagePreloader";
import {TopButtonBar} from "./helpers/TopButtonBar";
import {Logboek} from "./helpers/Logboek";
import {SessionSelection} from "./helpers/SessionSelection";
import {Pages} from "./helpers/Pages";
import {LocationsManager} from "./managers/Locations";
import {PupilsManager} from "./managers/Pupils";
import {LeerkrachtInfo} from "./containers/LeerkrachtInfo";
import {Popup} from "./containers/Popup";
import {FullscreenToggle} from "./helpers/FullscreenToggle";
import {BackgroundInfo} from "./containers/BackgroundInfo";


export class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loggedIn: false, fase_completed: -1, lastpage: -1, curr_fase: 0, curr_page: 0, init_done: false, session_active: false, session_selection_visible: false, show_settings: false, show_leerkracht_info: false, user_sessions:[], show_background_info:false

        };

        this.pageHandler = new Pages();
        this.logboek = new Logboek();
        this.user = {};


        this.last_textinput = {}; // de Page.js doet hier elke keer een name/value actie

        window.app = this; // ontsluit dit App-object via window.app zodat het vanuit elke component aangeroepen kan worden. Technisch is dan this.state ook voorhanden, gebruik echter de functies
    }

    componentDidMount() {
        this.pageHandler.loadPages();
    }

    /**
     * Zet de loginstatus op true zodat de knoppen van FaseNav actief worden
     *
     * @history
     * 20 juli 2022
     * Start implementatie
     *
     */
    setLoggedIn() {
        this.setState({"loggedIn": true});
    }

    /**
     * Zet de loginstatus op false zodat de data gereset kan worden en FaseNav gedeactiveerd, er wordt meteen naar de eerste pagina gesproken binnen de content
     *
     * @history
     * 20 juli 2022
     * Start implementatie
     *
     */
    setLoggedOut() {
        this.setState({
            "loggedIn": false, "fase_completed": -1, "lastpage": -1, "curr_fase": 0, "curr_page": 0, "session_active": false,

        });
    }


    handleLogin(p_user) {
        this.user = p_user;

        this.setState({
            loggedIn: true,
        })
    }


    activateSession(p_session) {
        let new_fase = 1;
        let new_page_index = 0;
        this.logboek.setLogboek(p_session.id, p_session.access_id1, p_session.access_id2,
            {"multiple_group_divisions": p_session.multiple_group_divisions,
                "multiple_instructions": p_session.multiple_instructions,
                "multiple_rounds": p_session.multiple_rounds,
                "student_mode":p_session.student_mode,
                "current_round": p_session.current_round,
                "round_status": p_session.round_status},
            p_session.spelend_data);
        console.log(p_session);
        if (p_session.spelend_data.lastpage != -1) {
            const fp = this.pageHandler.findPageFaseAndPageIndex(p_session.spelend_data.lastpage);
            if (fp.fase > 0) {
                new_fase = fp.fase;
                new_page_index = fp.page;
            }
        }

        this.setState({
            fase_completed: p_session.spelend_data.fase_completed, lastpage: p_session.spelend_data.lastpage, session_active: true, curr_fase: new_fase, curr_page: new_page_index
        })
    }

    initSessionSelection(p_sessions) {
        this.setState({
            session_active: false
        });


        this.setState({
            session_selection_visible: true,
            user_sessions: p_sessions
        });

    }

    async loadSession(p_session_id) {
        await this.logboek.loadLogboek(p_session_id);
        this.setState({
            session_active: true, session_selection_visible: false,


        });

    }

    async newSession() {
        await this.logboek.newLogboek();
        this.setState({
            session_active: true, session_selection_visible: false

        });
    }


    setLastTextInput(p_last_textinput) {
        this.last_textinput = p_last_textinput;
    }

    async storeFieldAndStoreLogboek(p_field, p_value) {
        this.logboek.updateField(p_field, p_value);
        await this.logboek.storeLogboek();
    }
    storeField(p_field, p_value)
    {

        this.logboek.updateField(p_field, p_value);
    }
    setSessionField(p_field, p_value)
    {
        this.logboek.updateSessionField(p_field, p_value);
    }


    async storeSessionFieldAndStoreLogboek(p_field, p_value) {

        this.logboek.updateSessionField(p_field, p_value);
        await this.logboek.storeLogboek();
    }

    async storeStoreLogboek(p_lastpage) {
        this.logboek.updateField("lastpage",p_lastpage);
        await this.logboek.storeLogboek();
    }

    async nextPage(p_pages=1) {
        console.log("next page: curr_fase:" + this.state.curr_fase +" curr_page:" + this.state.curr_page +" aantal pages verder " + p_pages)
        if (this.pageHandler.hasPageField(this.state.curr_fase, this.state.curr_page) && this.state.session_active) {
            if (this.pageHandler.isPageFieldRequired(this.state.curr_fase, this.state.curr_page) && this.last_textinput.value == "")
            {
                return;
            }
            await this.storeFieldAndStoreLogboek(this.last_textinput.name, this.last_textinput.value, this.state.lastpage);
        }

        if (this.pageHandler.getTotPages(this.state.curr_fase) > this.state.curr_page + p_pages) {
            let new_page = this.state.curr_page + p_pages;

            this.setState({
                "curr_page": new_page, "lastpage": this.pageHandler.getPageID(this.state.curr_fase, new_page)
            });
            if (this.state.session_active)
            {
                await this.storeStoreLogboek(this.pageHandler.getPageID(this.state.curr_fase, new_page));
            }
        } else {
            if (this.state.curr_fase != 7) {
                let new_fase = this.state.curr_fase + 1;
                let curr_page = p_pages - (this.pageHandler.getTotPages(this.state.curr_fase) - this.state.curr_page);


                this.setState({
                    "curr_page": curr_page, "curr_fase": new_fase, "lastpage": this.pageHandler.getPageID(new_fase, 0)
                });
                if (this.state.session_active)
                {
                    await this.storeStoreLogboek(this.pageHandler.getPageID(new_fase, 0));
                }
            }
        }

    }

    async prevPage(p_pages=1)
    {
        //console.log("prev page: curr_fase:" + this.state.curr_fase +" curr_page:" + this.state.curr_page +" aantal pages terug " + p_pages)
        if (this.pageHandler.hasPageField(this.state.curr_fase, this.state.curr_page) &&  this.state.session_active)
        {
            if (this.pageHandler.isPageFieldRequired(this.state.curr_fase, this.state.curr_page) && this.last_textinput.value == "")
            {
                return;
            }
            await this.storeFieldAndStoreLogboek(this.last_textinput.name, this.last_textinput.value);
        }
        if (this.state.curr_page - p_pages >= 0)
        {
            let new_page = this.state.curr_page - p_pages;
            this.setState({
                "curr_page": new_page, "lastpage": this.pageHandler.getPageID(this.state.curr_fase, new_page)
            })
            if (this.state.session_active)
            {
                await this.storeStoreLogboek(this.pageHandler.getPageID(this.state.curr_fase, new_page));
            }
        } else
        {
            if (this.state.curr_fase != 1)
            {
                let new_fase = this.state.curr_fase - 1;
                let pages_left_old_fase = this.state.curr_page;
                p_pages -=  pages_left_old_fase -1;
                let new_page = (this.pageHandler.getTotPages(new_fase) - p_pages)+1;
                console.log("new_fase: " + new_fase);
                console.log("new_page: " + new_page);

                this.setState({
                    "curr_page": new_page, "curr_fase": new_fase, "lastpage": this.pageHandler.getPageID(new_fase, 0)
                });
                if (this.state.session_active)
                {


                    await this.storeStoreLogboek(this.pageHandler.getPageID(new_fase, 0));
                }
            }
        }
    }

    async gotoFirstFasePage(p_fase) {
        if (!this.state.session_active) {
            return;
        }

        if (this.pageHandler.hasPageField(this.state.curr_fase, this.state.curr_page)) {
            if (this.pageHandler.isPageFieldRequired(this.state.curr_fase, this.state.curr_page) && this.last_textinput.value == "")
            {
                return;
            }
            await this.storeFieldAndStoreLogboek(this.last_textinput.name, this.last_textinput.value);
        }

        this.setState({
            "curr_page": 0, "curr_fase": p_fase, "lastpage": this.pageHandler.getPageID(p_fase, 0)
        });
        await this.storeStoreLogboek(this.pageHandler.getPageID(p_fase, 0));

    }

    downloadLog(p_session_id)
    {

        document.getElementById("app_user_id").value = window.app.user.id;
        document.getElementById("wachtwoord").value = window.app.user.password;
        document.getElementById("session_id").value = p_session_id;
        document.getElementById('frmDownloadLog').submit();
    }

    deleteSession(p_session_id)
    {
        if (window.confirm("Deze sessie met ALLE gegevens en logs echt verwijderen?")) {
            const formData = new FormData();
            formData.append("app_user_id",  window.app.user.id);
            formData.append("wachtwoord", window.app.user.password);
            formData.append("session_id",  p_session_id);

            const requestOptions = {
                method: 'POST',
                body: formData
            };

            fetch("/delete_spelend", requestOptions)
                .then(response => response.json())
                .then(sessions_json => {
                    if (sessions_json.status == "ok") {

                        this.initSessionSelection(sessions_json.data.sessions);

                    } else {
                        console.log("?");
                    }
                });
        }
    }



    async logoutClicked() {
        if (window.confirm("Wil je echt uitloggen?")) {
            if (this.pageHandler.hasPageField(this.state.curr_fase, this.state.curr_page)) {
                await this.storeFieldAndStoreLogboek(this.last_textinput.name, this.last_textinput.value);
            }
        }
        window.location.href = window.location.href;
    }


    getFaseNaam(p_fase) {
        switch (p_fase) {
            case 0 :
                return "<strong>Voorbereiden;</strong><br/>Wat is er nodig? Hoe ga ik het doen";
                break;
            case    1:
                return "<strong>Confronteren;</strong><br/>Ik start (wat, waar, wie?)";
                break;
            case    2 :
                return "<strong>Verkennen;</strong><br/>Ik zoek uit";
                break;
            case    3 :
                return "<strong>Ontwerpen;</strong><br/>Ik denk na";
                break;
            case    4 :
                return "<strong>Ontwerp realiseren;</strong><br/>Ik werk";
                break;
            case    5 :
                return "<strong>Testen;</strong><br/>Ik test";
                break;
            case   6 :
                return "<strong>Presenteren;</strong><br/>Ik presenteer";
                break;
            case   7 :
                return "<strong>Verdiepen;</strong><br/>Ik ga verder";
                break;
        }
    }

    openSettingsClicked() {
        this.setState({show_settings: true});
    }

    closeSettingsClicked() {
        this.setState({show_settings: false});
    }


    showLeerkrachtInfoClicked() {
        this.setState({show_leerkracht_info: true});
    }

    closeLeerkrachtInfoClicked() {
        this.setState({show_leerkracht_info: false});
    }

    showBackgroundInfoClicked() {
        this.setState({show_background_info: true});
    }

    closeBackgroundInfoClicked() {
        this.setState({show_background_info: false});
    }


    render() {
        return (<>

            <div className="tool__wrapper">
                <div className={"tool_wrapper__logo_top"}>
                    <img src={"/digibord/assets/svgs/logo_spelendleren.svg"} style={{"width": "100%"}}
                         alt={"Spelendleren"}/>
                </div>


                    {this.state.init_done  && (<>
                        <FaseNav loggedIn={this.state.loggedIn} curr_fase={this.state.curr_fase}/>


                        <ContentWrapper loggedIn={this.state.loggedIn} curr_fase={this.state.curr_fase}
                                        curr_page={this.state.curr_page} session_active={this.state.session_active} sessions={this.state.user_sessions}/>
                    </>)}



                    {!this.state.init_done && (<ContentPagePreloader/>)}


                    <TopButtonBar loggedIn={this.state.loggedIn} show_logboek={this.state.session_active}/>



                {this.state.show_settings && (
                    <Popup title={"Algemene instellingen"} has_close_btn={true} callback={()=>this.setState({"show_settings":false})}>
                        <LocationsManager session_active={this.state.session_active}/>
                        <PupilsManager session_active={this.state.session_active}/>
                    </Popup>
                )}

                {this.state.show_leerkracht_info && (<LeerkrachtInfo teacher_pages={this.pageHandler.getTeacherInfo(this.state.curr_fase, this.state.curr_page)}/>)}


                {this.state.show_background_info && (<BackgroundInfo background_pages={this.pageHandler.getBackgroundInfo(this.state.curr_fase, this.state.curr_page)}/>)}


                <div className={"tool_wrapper__logo_bottom"}>
                    <img src={"/digibord/assets/svgs/logo_spelendleren_met_wur.svg"} style={{"width": "100%"}}
                         alt={"Spelendleren - WUR"}/>
                </div>

                <FullscreenToggle/>
            </div>


            <form method="post" action="/download_log" id="frmDownloadLog" name="frmDownloadLog">
                <input type="hidden" name="app_user_id" id="app_user_id" value=""/>
                <input type="hidden" name="wachtwoord" id="wachtwoord" value=""/>
                <input type="hidden" name="session_id" id="session_id" value=""/>

            </form>

        </>);
    }
}
